import { create } from "zustand";
import { persist } from "zustand/middleware";
import { initialExpand, InitialExpandItm } from "../initialValues/index";

interface AccordionState {
  expanded: InitialExpandItm[];
  setExpandedFromEdit: () => void;
  handleAccordClick: (name: string) => void;
  handleMinimize: () => void;
}

export const useAccordion = create<AccordionState>()(
  persist(
    (set, get) => ({
      expanded: JSON.parse(JSON.stringify(initialExpand)),
      setExpandedFromEdit: () =>
        set((state: AccordionState) => ({
          ...state,
          expanded: JSON.parse(JSON.stringify(initialExpand)).map(
            (itm: InitialExpandItm) => ({ ...itm, expanded: true })
          ),
        })),
      handleAccordClick: (name: string) =>
        set((state: AccordionState) => ({
          ...state,
          expanded: state.expanded.map((accord: InitialExpandItm) =>
            accord.name === name
              ? { ...accord, expanded: !accord.expanded }
              : { ...accord }
          ),
        })),
      handleMinimize: () =>
        set((state: AccordionState) => ({
          ...state,
          expanded: JSON.parse(JSON.stringify(initialExpand)),
        })),
    }),
    {
      name: "accordionControl",
      partialize: (state: AccordionState) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              ![
                "handleMinimize",
                "handleAccordClick",
                "setExpandedFromEdit",
              ].includes(key)
          )
        ),
    }
  )
);
